<template>
    <v-dialog
        v-model="innerValue"
        v-bind="$attrs"
        max-width="30em"
    >
        <v-card :loading="loading && 'white'">
            <v-toolbar
                color="primary"
                dark
                flat
            >
                <v-toolbar-title>
                    Invite a new user
                </v-toolbar-title>
            </v-toolbar>

            <v-card-text class="mt-6">
                <v-form ref="form">
                    <v-row>
                        <v-col>
                            <!-- Email -->
                            <v-text-field
                                key="email"
                                v-model="email"
                                v-validate="'required|email'"
                                name="email"
                                label="Email"
                                color="primary"
                                outlined
                                required
                                :error-messages="errors.first('email')"
                            />
                        </v-col>
                        <v-col
                            class="flex-grow-0 pl-0"
                            right
                        >
                            <v-btn
                                color="primary white--text"
                                height="56"
                                depressed
                                x-large
                                :disabled="disabled"
                                @click.native="inviteUser"
                            >
                                Invite
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>

                <v-row>
                    <v-col>
                        <v-text-field
                            :value="$_user.referral_code"
                            :loading="loading"
                            label="Referral Link"
                            color="primary"
                            hide-details
                            outlined
                            readonly
                        />
                    </v-col>
                </v-row>
            </v-card-text>

            <div class="d-flex justify-center">
                <v-col
                    cols="7"
                    md="12"
                    lg="7"
                >
                    <v-card-actions class="justify-center justify-lg-space-between">
                        <v-btn
                            color="primary"
                            outlined
                            @click="copyToClipboard(referralLink)"
                        >
                            Copy
                        </v-btn>

                        <v-btn
                            color="primary"
                            outlined
                            @click="showEditReferralCodeModal = true"
                        >
                            Edit
                        </v-btn>

                        <v-btn
                            color="primary"
                            outlined
                            @click="showShareReferralCodeModal = true"
                        >
                            Share
                        </v-btn>
                    </v-card-actions>
                </v-col>
            </div>
        </v-card>

        <EditReferralCodeModal
            v-model="showEditReferralCodeModal"
        />

        <ShareReferralCodeModal
            v-model="showShareReferralCodeModal"
        />
    </v-dialog>
</template>

<script>
/* eslint-disable camelcase */
import { mapGetters } from 'vuex';

import EditReferralCodeModal from '../components/referral-code/edit-referral-code-modal.vue';
import ShareReferralCodeModal from '../components/referral-code/share-referral-code-modal.vue';

export default {
    components: {
        EditReferralCodeModal,
        ShareReferralCodeModal,
    },
    props: {
        value: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data: () => ({
        loading: false,
        email: '',
        showEditReferralCodeModal: false,
        showShareReferralCodeModal: false,
    }),
    computed: {
        ...mapGetters([
            'userSettings',
        ]),
        innerValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
        disabled() {
            return this.errors.any() || !this.email;
        },
        referralLink() {
            const route = this.$router.resolve({
                name: 'referral-page',
                params: {
                    referralCode: this.$_user.referral_code,
                },
            });
            return `${window.location.origin}${route.href}`;
        },
    },
    methods: {
        async inviteUser() {
            try {
                this.loading = true;
                const valid = await this.$validator.validateAll();
                if (valid) {
                    const { email } = this;
                    await Vue.backendApi()
                        .inviteUser({ email });

                    // Reset invitation form
                    this.email = '';
                    this.$validator.reset();

                    this.$swal({
                        type: 'success',
                        title: 'User invited!',
                        text: 'Click okay to continue',
                    });
                }
            } catch (error) {
                this.$swal({
                    type: 'error',
                    title: 'Error inviting user',
                    text: error,
                });
            } finally {
                this.listInvitedUser();
                this.loading = false;
            }
        },
    },
};
</script>
